import { useSpring, animated } from "@react-spring/web";
import { useSelector } from 'react-redux';

function SendingPage() {
  const navbarHeight = useSelector((state) => state.navbarHeight);

  const springProps = useSpring({
    from: { y: 0, opacity: 0 },
    to: async (next) => {
      while (true) {
        await next({ y: -20, opacity: 1 });
        await next({ y: 0, opacity: 1 });
        await next({ y: 0, opacity: 0 });
      }
    },
    config: { mass: 1, tension: 150, friction: 30 },
  });

  const shiningText = useSpring({
    from: { y: 0, opacity: 0, color: "#333" },
    to: async (next) => {
      while (true) {
        await next({ color: "#FFA500" });
        await next({ color: "#8B0000" });
      }
    },
    config: { mass: 1, tension: 150, friction: 41.5 },
  });  

  return (
    <main
      className="flex flex-col justify-center items-center"
      style={{ height: `calc(100vh - ${navbarHeight}px)` }}
    >
      <animated.svg
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        viewBox="0 0 24 24"
        aria-hidden="true"
        height="5em"
        width="5em"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: springProps.y.to((y) => `translateY(${y}px)`), opacity: springProps.opacity }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
        />
      </animated.svg>
      <animated.h1
        className="main-font text-lg md:text-xl"
        style={{ color: shiningText.color }}
      >
        Sending message.
      </animated.h1>
    </main>
  );
}

export default SendingPage;
